import { type Media as PayloadMedia } from '@/payload-types';
import { Container } from '@/website/components/Container';
import { Media } from '@/website/components/Media';
import { Button } from '@/website/components/ui/button';
import { cn } from '@/website/utils/tailwindUtils';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
    logo: string | PayloadMedia;
    link?: string;
    hidePartnerButton?: boolean;
    isDefaultPartner: boolean;
};

export const ClientHeader = (props: Props) => {

	const { logo, link, hidePartnerButton, isDefaultPartner } = props;

	return (
		<header
			className={cn(
				'header',
				'bg-(--nav-bar-background) text-(--nav-bar-text)',
				'header-css-pick'
			)}
		>
			<Container
					className={cn(
					'py-(--ds-spacing-xs) px-(--ds-spacing-sm)',
					'flex items-center justify-between md:gap-y-0',
					'lg:py-3 lg:px-10'
				)}
			>
				<Link
					href={link ?? '/'}
					className={cn(
						'header__logo',
						'relative h-screen max-h-10',
						'block'
					)}
					style={{ aspectRatio: `${typeof logo === 'string' ? undefined : logo ? `${logo.width}/${logo.height}` : undefined}`}}
				>
					{typeof logo === 'string' ? (
						<Image
							src={logo}
							alt='Playdia'
							fill={true}
							className={cn('object-contain site-header-logo')}
							priority
						/>
					) : (
						<Media
							resource={logo}
							fill={true}
							className={cn('object-contain site-header-logo')}
							priority
						/>
					)}
				</Link>
				{(!hidePartnerButton && isDefaultPartner) && (
					<Button
						className={cn(
							'become-partner',
							'px-[1.0625rem] py-[0.375rem] text-base !leading-[1.1875]',
							'sm:px-[2.3125rem] sm:py-[0.9375rem] sm:text-lg sm:!leading-[0.725]'
						)}
					>
						<Link href="/become-a-partner">
							Become a partner
						</Link>
					</Button>
				)}
			</Container>
		</header>
	)
}
